import { Component, OnInit } from '@angular/core';
import { CodeSystemService } from 'app/mdm/terminology/codesystem/services/codesystem.service';
import { CodeSystem } from 'app/mdm/terminology-lib/services/codesystem';
import { LocalStorageService, sort } from '@heda/core-util';

@Component({
  templateUrl: './codesystem-list.component.html',
})
export class CodeSystemListComponent implements OnInit {
  public items: Array<CodeSystem> = [];
  public search: string;

  constructor(private codeSystemService: CodeSystemService, private localStorageService: LocalStorageService) {}

  public ngOnInit(): void {
    this.search = this.localStorageService.get('codesystem-filter');
    this.codeSystemService.getCodeSystems().subscribe((resp) => (this.items = sort(resp, 'id', true)));
  }

  public onSearchChange(str: string): void {
    this.localStorageService.put('codesystem-filter', str);
  }

  public clearSearch(): void {
    this.search = null;
    this.onSearchChange(null);
  }
}
